import { Col, List, Row } from "antd";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import styles from "./UpcomingEvents.module.css";
import {
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import guestImg1 from "../../../../assets/staticImages/guest1.png";
import placeholder from "../../../../assets/dummy.png";
import Modal from "../../../../components/modal/Modal";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { GuestMiddleware } from "../../../../Store/Middlewares/GuestMiddleware";
import { eventDatailsGuest } from "../../../../Store/Actions/GuestActions";

const groups = [
  {
    title: "Family",
    show: true,
    header: {
      name: "You have 3 upcoming events",
      date: "Event Date",
      time: "Event Time",
      actions: "Actions",
    },
    guests: [
      {
        name: "Wedding Rehearsal",
        address: "3707 Irving Place, Arnold, MO 63010",
        date: "May 12, 2023",
        time: "8:30 PM",
        active: true,
      },
      {
        name: "James & Lucy Marriage",
        address: "3707 Irving Place, Arnold, MO 63010",
        date: "May 20, 2023",
        time: "8:30 PM",
        active: false,
      },
      {
        name: "Engagement Ceremony",
        address: "3707 Irving Place, Arnold, MO 63010",
        date: "May 15, 2023",
        time: "8:30 PM",
        active: false,
      },
    ],
  },
];

const ShareModal = ({ setShowModal }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [otpError, setOtpError] = useState(null);
  const otpBoxReference = useRef([]);

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if (value && index < 6 - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  function handleBackspaceAndEnter(e, index) {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 6 - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  // useEffect(() => {
  //   if(otp.join("") !== "" && otp.join("") !== correctOTP){
  //     setOtpError("❌ Wrong OTP Please Check Again")
  //   }else{
  //     setOtpError(null)
  //   }
  //  }, [otp]);

  return (
    <Row className={styles.modalContentRow}>
      <Col xs={24}>
        <svg
          className={styles.svgIcon}
          viewBox="0 0 297 303"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M198.307 152.028C198.307 199.669 198.191 247.309 198.438 294.95C198.468 301.001 196.995 302.762 190.9 302.732C129.911 302.496 68.9215 302.525 7.94664 302.718C2.21658 302.732 0.0441117 301.652 0.058692 295.202C0.248236 199.684 0.248236 104.151 0.058692 8.61799C0.0441117 2.52235 1.64795 0.820901 7.69877 0.835697C68.6882 1.05763 129.663 1.10201 190.652 0.791311C197.403 0.761721 198.468 2.95141 198.438 9.10623C198.191 56.7469 198.307 104.387 198.307 152.028ZM37.4572 67.3107C43.8434 73.4063 48.8007 78.3923 54.0496 83.0528C56.7469 85.4496 57.4176 87.8168 56.6157 91.3973C55.0848 98.2623 54.1662 105.275 52.7957 113.383C60.115 109.669 66.5886 106.607 72.8436 103.145C76.1533 101.31 78.9382 101.207 82.2916 103.071C88.532 106.548 94.9911 109.61 102.34 113.339C101.027 105.645 100.327 99.076 98.7091 92.7437C97.4843 87.9796 98.7382 84.991 102.267 81.9579C107.268 77.6525 111.817 72.8441 117.561 67.2811C109.017 66.0087 102.179 64.6919 95.2681 64.0557C91.069 63.671 88.9694 61.6885 87.2927 58.0193C84.5078 51.9088 81.2273 46.0203 77.5385 38.8446C73.733 46.331 70.3941 52.471 67.478 58.8034C65.9908 62.0583 63.935 63.5971 60.4503 64.0113C53.3351 64.8251 46.2783 66.0087 37.4572 67.3107ZM99.1756 221.003C117.809 221.003 136.428 220.856 155.062 221.107C159.698 221.166 161.871 219.953 161.273 215.026C161.069 213.34 161.011 211.549 161.273 209.877C162.352 203.205 159.451 201.814 153.225 201.858C118.626 202.169 84.0413 202.006 49.4422 202.021C37.0344 202.021 37.3697 202.051 37.0198 214.301C36.8594 220.042 38.7694 221.225 44.0183 221.137C62.4041 220.811 80.7899 221.003 99.1756 221.003ZM86.724 246.111C74.1704 246.111 61.6167 246.111 49.0631 246.111C37.0635 246.111 37.4134 246.126 37.0198 257.932C36.8156 263.895 38.7694 265.271 44.3537 265.212C70.9044 264.931 97.4697 265.241 124.035 265.034C137.741 264.931 136.035 268.171 136.487 252.014C136.632 246.94 134.664 245.948 130.188 246.022C115.695 246.259 101.217 246.111 86.724 246.111ZM74.7244 176.884C84.8723 176.884 95.0494 176.603 105.183 177.002C110.315 177.195 112.269 175.523 111.554 170.404C111.321 168.717 111.321 166.942 111.554 165.255C112.342 159.529 110.184 157.68 104.381 157.798C86.2575 158.168 68.1196 157.931 49.9817 157.931C36.4366 157.931 36.5824 157.931 37.0635 171.913C37.1947 175.774 38.332 177.002 42.0937 176.929C52.9706 176.751 63.8475 176.884 74.7244 176.884ZM160.515 98.1587C146.751 99.727 140.423 92.3738 136.239 80.9075C133.075 93.5574 125.187 98.7653 112.429 98.425C123.306 105.305 125.683 114.404 120.784 126.477C127.082 123.547 131.675 119.715 136.239 119.745C141.065 119.775 145.862 123.488 152.102 126.225C147.524 114.463 149.113 105.26 160.515 98.1587Z"
            className={styles.svgIconPath}
          />
          <path
            d="M223.066 298.352C223.066 288.824 223.066 279.296 223.066 269.768C223.066 205.201 223.066 140.65 223.066 76.0835C223.066 67.887 223.096 67.8574 230.765 70.6833C251.192 78.1992 271.604 85.7892 292.06 93.2164C295.749 94.5628 297.528 95.6724 295.808 100.451C272.275 165.55 248.99 230.753 225.618 295.911C225.297 296.799 224.729 297.612 224.277 298.456C223.883 298.411 223.475 298.382 223.066 298.352Z"
            className={styles.svgIconPath}
          />
        </svg>
        {/* </Col>

      <Col> */}
        <TextComponent textClass={styles.modalText1}>
          Enter Code To Accept
        </TextComponent>
        <TextComponent textClass={styles.modalText2}>
          Invitation!!
        </TextComponent>
        <Row>
          {/* {inputs.map((value, i) => {
            return (
              <input
                key={i}
                defaultValue={null}
                placeholder={value}
                className={styles.modalInput}
                maxLength="1"
                onChange={(e) => handleInputChange(e, i)}
                // onKeyDown={(e) => handleBackspace(e, i)}
                // value={value}
                // disabled={i > 0 && !inputValues[i - 1]}
                // value={inputRef.current && inputRef.current.value}
              />
            );
          })} */}
          {otp.map((digit, index) => (
            <input
              key={index}
              value={digit}
              maxLength={1}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
              ref={(reference) => (otpBoxReference.current[index] = reference)}
              className={styles.modalInput}
            />
          ))}
        </Row>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Done"
            btnClass={styles.modalBtn}
            onClick={() => {
              console.log(otp.join(""));
              setShowModal(false);
            }}
          />
        </div>
      </Col>
    </Row>
  );
};

const TableHeader = ({ item }) => {
  return (
    <Row className={styles.listItemFirst}>
      <Col xs={24} lg={9}>
        <div className={styles.itemGroup1First}>
          <TextComponent text={item.name} textClass={styles.eventTitle} />
        </div>
      </Col>
      <Col xs={24} lg={15}>
        <Row className={styles.itemGroup2First}>
          <Col xs={5} className={styles.group2first}>
            <TextComponent text={item.date} />
          </Col>
          <Col xs={7} className={styles.group2second}>
            <TextComponent text={item.time} />
          </Col>
          <Col xs={24} sm={8} lg={8} xl={6} className={styles.group2third}>
            <TextComponent text={item.actions} textClass={styles.guests} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <div
        className={
          item.status == "Active" ? styles.greenCircle : styles.inActiveCircle
        }
      ></div>
      <img
        src={item?.image ? item?.image : placeholder}
        style={{ width: "60px" }}
      ></img>
      <div className={styles.textGroup}>
        {item.status == "Active" && (
          <TextComponent
            text={"Active"}
            textClass={styles.activeText}
          ></TextComponent>
        )}
        <TextComponent text={item?.name} textClass={styles.eventTitle} />
        <TextComponent text={item?.address} textClass={styles.eventAddr} />
      </div>
    </div>
  );
};

const RightGroup = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <Row className={styles.itemGroup2}>
      <Col xs={24} sm={8} lg={5} className={styles.group2first}>
        <TextComponent text="Event Date" textClass={styles.infoTitle} />
        <TextComponent text={moment(item.date).format("MMM DD YYYY")} />
      </Col>
      <Col xs={24} sm={8} lg={7} className={styles.group2second}>
        <TextComponent text="Event Time" textClass={styles.infoTitle} />
        <TextComponent text={moment(item?.start_time).format("hh:mm A")} />
      </Col>
      <Col xs={24} sm={8} lg={8} xl={6} className={styles.group2third}>
        <TextComponent text="Actions" textClass={styles.infoTitle} />
        {/* <TextComponent text={item.time} textClass={styles.guests} /> */}
        <Row className={styles.actionRow}>
          <SubmitButton
            title={"Event Overview"}
            btnClass={styles.actionBtn1}
            onClick={() => {
              navigate("/guestEventOverview", {
                state: { headrTitle: "Event", eventData: item },
              });
            }}
          />
          {/* <SubmitButton
            title={item?.is_accepted_invitation ? "Details" : "RSVP"}
            btnClass={styles.actionBtn1}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(GuestMiddleware.guestRsvpDetails(item?.id))
                .then(() => {
                  navigate(
                    item?.is_accepted_invitation
                      ? "/rsvp/rsvpGuestJoinLive"
                      : "/rsvp/rsvpIntro"
                  );
                })
                .catch((err) => {
                  console.log(err);
                });
            }}
          />
          <SubmitButton
            title="Gallery"
            btnClass={styles.actionBtn2}
            onClick={(e) => {
              e.stopPropagation();
              navigate("/events/gallery", {
                state: { headrTitle: "Gallery", eventData: item },
              });
            }}
          /> */}
        </Row>
      </Col>
    </Row>
  );
};

const UpcomingEvents = () => {
  // const [modalOpen, setModalOpen] = useState(true);
  const { height, width } = useWindowDimensions();
  const events = useSelector(
    (state) => state?.GuestReducer?.guestUpcomingEvents
  );

  const ref = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    // let userData = {
    //   status: "upcoming",
    //   name: "",
    // };
    dispatch(GuestMiddleware.guestUpcomingEvents()).then((data) => {});
  }, []);

  const onSearch = (val) => {
    let userData = {
      status: "upcoming",
      name: val,
    };
    // setSearch(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      // setloading(true);
      // setHloading(true);
      dispatch(GuestMiddleware.guestUpcomingEvents(val))
        .then((data) => {
          // setloading(false);
          // setHloading(false);
        })
        .catch(() => {
          // setloading(false);
          // setHloading(false);
        });
    }, 1500);
  };
  return (
    <>
      <Row>
        <Col xs={24} md={12} xl={9}>
          <SearchInput
            placeholder="Search"
            onChange={(e) => onSearch(e.target.value)}
          />
        </Col>
      </Row>
      {/* {groups.map((group) => ( */}
      <List
        // key={group.title}
        header={
          <TableHeader
            item={{
              name: `You have ${
                events?.length > 0 ? events?.length : "0"
              } upcoming events`,
              date: "Event Date",
              time: "Event Time",
              actions: "Actions",
            }}
          />
        }
        className={styles.list}
        itemLayout={width > 991 ? "horizontal" : "vertical"}
        dataSource={events?.length > 0 ? events : []}
        renderItem={(item, index) => (
          <List.Item
            className={styles.listItem}
            // onClick={() => setModalOpen(true)}
          >
            <Col xs={24} lg={9}>
              <LeftGroup item={item} />
            </Col>
            <Col xs={24} lg={15}>
              <RightGroup item={item} />
            </Col>
          </List.Item>
        )}
      />
      {/* ))} */}
      {/* {modalOpen && (
        <Modal
          isModalOpen={modalOpen}
          setIsModalOpen={setModalOpen}
          closable={true}
        >
          <ShareModal setShowModal={setModalOpen} />
        </Modal>
      )} */}
    </>
  );
};

export default UpcomingEvents;
